import React from "react";
import { useIntl } from "react-intl";

import { useFormatName } from "src/common/hooks/useFormatName";
import { useFormatRole } from "src/common/hooks/useFormatRole";
import { Invitation, RawInvitation } from "src/views/invitation-list/types";

export function useNormalizeInvitation(): (
	invitation: RawInvitation
) => Invitation {
	const { formatDate } = useIntl();

	const formatName = useFormatName();
	const formatRole = useFormatRole();

	return React.useCallback(
		({
			token,
			generated,
			expires,
			title,
			firstName,
			lastName,
			email,
			role
		}: RawInvitation): Invitation => {
			const formatDateOpts = {
				year: "numeric",
				month: "numeric",
				day: "numeric",
				hour: "numeric",
				minute: "numeric",
				second: "numeric"
			} as const;
			return {
				token,
				generated: formatDate(generated, formatDateOpts),
				expires: formatDate(expires, formatDateOpts),
				name: formatName({ title, firstName, lastName }),
				email,
				role: formatRole(role)
			};
		},
		[formatName, formatRole, formatDate]
	);
}
